var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{staticClass:"testimonial"},[_c('blockquote',[_c('RichText',{staticClass:"testimonial__content",attrs:{"content":_vm.testimonial.Description}})],1),_c('div',{staticClass:"testimonial__author"},[_vm._v(_vm._s(_vm.testimonial.ClientName)+_vm._s(_vm.testimonial.Suburb ? `, ${_vm.testimonial.Suburb}` : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }